import { Pod } from '@rhg/components/pod';
import { partnerActivationMessages } from '@rhg/lang/messages/partner-activation';
import { Button, Stack } from '@rhg/libs/material';
import { WarningWithCircleBackgroundWhite } from '@rhg/libs/material/icons/warning-with-circle-background-white';
import { routes } from '@rhg/utils/routes';
import { useIntl } from 'react-intl';

const wrapper = {
    pt: 4,
    px: 2,
};

const podStyle = {
    width: { xs: '100%', md: '40%' },
};

export type PartnerActivationErrorVariant = 'invalid' | 'expired' | 'retry';

const messagesByVariant = {
    invalid: {
        heading:
            partnerActivationMessages['partner_activation.invalid_heading'],
        description:
            partnerActivationMessages['partner_activation.invalid_description'],
    },
    expired: {
        heading:
            partnerActivationMessages['partner_activation.expired_heading'],
        description:
            partnerActivationMessages['partner_activation.expired_description'],
    },
    retry: {
        heading: partnerActivationMessages['partner_activation.retry_heading'],
        description:
            partnerActivationMessages['partner_activation.retry_description'],
    },
};

export function PartnerActivationError({
    variant,
}: {
    variant: PartnerActivationErrorVariant;
}) {
    const { formatMessage } = useIntl();
    const { heading, description } = messagesByVariant[variant];

    return (
        <Stack sx={wrapper} alignItems="center" gap={4}>
            <Pod
                sx={podStyle}
                sections={[
                    {
                        icon: <WarningWithCircleBackgroundWhite />,
                        title: formatMessage(heading),
                        titleComponent: 'h1',
                        subtitle: formatMessage(description),
                    },
                ]}
            />
            {variant === 'retry' && (
                <Stack gap={2} sx={podStyle}>
                    <Button
                        skipTracking
                        href={routes.partnerMemberActivation}
                        color="primary"
                        variant="contained"
                    >
                        {formatMessage(
                            partnerActivationMessages[
                                'partner_activation.try_again'
                            ]
                        )}
                    </Button>
                    <Button
                        skipTracking
                        href={routes.dashboard}
                        color="primary"
                        variant="outlined"
                    >
                        {formatMessage(
                            partnerActivationMessages[
                                'partner_activation.go_to_calm_health'
                            ]
                        )}
                    </Button>
                </Stack>
            )}
        </Stack>
    );
}
